import { Phone, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { COMPANY } from "../../data/content";

export const CTABand = ({ testId = "cta-band" }) => (
  <section data-testid={testId} className="bg-[#B5651D]">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
      <Reveal>
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-white tracking-tight">
          Bereit für Ihr Projekt?
        </h2>
        <p className="mt-1 text-white/85 text-sm md:text-base">
          Kostenlose Erstberatung — wir melden uns schnell und zuverlässig.
        </p>
      </Reveal>
      <Reveal delay={0.1} className="flex flex-col sm:flex-row gap-3 shrink-0">
        <button
          data-testid={`${testId}-offer-btn`}
          onClick={() => document.querySelector("#kontakt")?.scrollIntoView({ behavior: "smooth" })}
          className="inline-flex items-center justify-center gap-2 bg-[#1F2933] text-white px-7 py-3.5 text-sm uppercase tracking-wider font-semibold transition-all duration-300 hover:bg-[#0f161d] hover:-translate-y-0.5"
        >
          Angebot anfordern <ArrowRight size={16} />
        </button>
        <a data-testid={`${testId}-call-btn`} href={COMPANY.phoneLink} className="btn-light">
          <Phone size={16} /> {COMPANY.phone}
        </a>
      </Reveal>
    </div>
  </section>
);
